"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _CardActions = _interopRequireDefault(require("@mui/material/CardActions"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ActionItem = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginLeft: theme.spacing(2),
    display: 'inline-flex',
    alignItems: 'center'
  };
});

/**
 * アクションボタン表示
 * @prop {array} [actions] - 表示するボタン要素の配列
 * @prop {node} [children] - ボタン以外に表示するコンテンツ
 */
class CActions extends _react.default.Component {
  render() {
    const {
      children,
      actions
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Array.isArray(actions) && actions.length > 0 && /*#__PURE__*/_react.default.createElement(_CardActions.default, null, actions.map((item, index) => {
      return /*#__PURE__*/_react.default.createElement(ActionItem, {
        key: 'CActions_' + index
      }, item || null);
    }), children && children));
  }
}
CActions.propTypes = {
  actions: _propTypes.default.array,
  children: _propTypes.default.node
};
var _default = exports.default = CActions;